import { render, staticRenderFns } from "./FleetSummary.vue?vue&type=template&id=2831105d&scoped=true&"
import script from "./FleetSummary.vue?vue&type=script&lang=js&"
export * from "./FleetSummary.vue?vue&type=script&lang=js&"
import style0 from "./FleetSummary.vue?vue&type=style&index=0&id=2831105d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831105d",
  null
  
)

export default component.exports